import { render, staticRenderFns } from "./OrganismTechnicalSpecsV2.vue?vue&type=template&id=938b5030&scoped=true&"
import script from "./OrganismTechnicalSpecsV2.vue?vue&type=script&lang=js&"
export * from "./OrganismTechnicalSpecsV2.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTechnicalSpecsV2.vue?vue&type=style&index=0&id=938b5030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938b5030",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomBulletSpecsNoCategory: require('/app/components/atoms/common/AtomBulletSpecsNoCategory.vue').default,AtomsCommonAtomSpecsInfo: require('/app/components/atoms/common/AtomSpecsInfo.vue').default,AtomsProjectAtomCategorySpecs: require('/app/components/atoms/project/AtomCategorySpecs.vue').default})
